export default __webpack_public_path__ + "static/diamond-5-a1c319484ff40f268a8821a130e86f19.png";